import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import LegacyGone from "@/components/LegacyGone";

export const Route = createFileRoute("/products/mindcruiser/$")({
  head: () => pageHead("Page No Longer Available", "This page was part of a previous version of our website and has been permanently removed.", "/products/mindcruiser/$", false),
  component: LegacyGone,
});
